import type { FilterConfig } from "../types";
import { ENTITY_KIND_ICON } from "#app/lib/entity-visuals";
import {
  STRING_OPERATORS,
  ID_OPERATORS,
  ID_ARRAY_OPERATORS,
  DATE_OPERATORS,
  BOOLEAN_OPERATORS,
  isIn,
  nin,
  isNull,
  isNotNull,
} from "../operators";

// `satisfies` rather than an annotation: `FilterConfig.fields` is a
// `Record<string, …>`, and annotating would widen these literal keys away, so
// every derived config (the map's subset) would read `FilterFieldDef |
// undefined` for a field written out right here.
export const issueFilterConfig = {
  category: "issues",
  searchableFields: ["name", "description"],
  quickFilters: [
    {
      field: "assignees.entityId",
      label: "Assignees",
      type: "entity-assignee",
      operator: "hasSome",
      icon: ENTITY_KIND_ICON.user,
    },
    {
      field: "assigneeTeamIds",
      label: "Team",
      type: "entity-team",
      operator: "hasSome",
      icon: ENTITY_KIND_ICON.team,
    },
    {
      field: "issueTypeId",
      label: "Project Type",
      type: "issue-type",
      operator: "in",
      icon: ENTITY_KIND_ICON.issueType,
    },
    {
      field: "age.status",
      label: "Age",
      type: "age-status",
      operator: "in",
      icon: "clock",
    },
    {
      field: "workflow-stage",
      label: "Workflow",
      type: "workflow-stage",
      operator: "in",
      icon: ENTITY_KIND_ICON.workflow,
    },
    {
      field: "lastUpdateDate",
      label: "Last updated",
      type: "last-updated",
      operator: "eq",
      icon: "calendar-clock",
    },
    {
      field: "archived",
      label: "More",
      type: "more-options",
      operator: "eq",
      icon: "more-horizontal",
    },
  ],
  fields: {
    name: {
      field: "name",
      label: "Name",
      type: "string",
      operators: STRING_OPERATORS,
    },
    description: {
      field: "description",
      label: "Description",
      type: "string",
      operators: STRING_OPERATORS,
    },
    stageId: {
      field: "stageId",
      label: "Stage",
      type: "stage",
      operators: [isIn("Includes any of"), nin("Excludes"), isNull("Is empty"), isNotNull("Is not empty")],
    },
    workflowId: {
      field: "workflowId",
      label: "Workflow",
      type: "workflow",
      operators: ID_OPERATORS,
    },
    issueTypeId: {
      field: "issueTypeId",
      label: "Project Type",
      type: "issue-type",
      operators: [isIn("Includes any of"), nin("Excludes"), isNull("Is empty"), isNotNull("Is not empty")],
    },
    "assignees.entityId": {
      field: "assignees.entityId",
      label: "Assignee",
      type: "entity-assignee",
      operators: ID_ARRAY_OPERATORS,
    },
    assigneeTeamIds: {
      field: "assigneeTeamIds",
      label: "Team",
      type: "entity-team",
      operators: ID_ARRAY_OPERATORS,
    },
    creationDate: {
      field: "creationDate",
      label: "Created",
      type: "date",
      operators: DATE_OPERATORS,
    },
    archived: {
      field: "archived",
      label: "Archived",
      type: "boolean",
      operators: BOOLEAN_OPERATORS,
    },
    "age.status": {
      field: "age.status",
      label: "Age Status",
      type: "age-status",
      operators: [isIn("Includes any of"), nin("Excludes")],
    },
    lastUpdateDate: {
      field: "lastUpdateDate",
      label: "Last Updated",
      type: "date",
      operators: DATE_OPERATORS,
    },
  },
} satisfies FilterConfig;
